import React from 'react';
import { Icons, Modal, Tooltip } from '~/components';

function TextoColunaCompleto({
  preview,
  truncado,
  nomeColuna,
  onVerCompleto,
  carregando = false,
}) {
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        maxWidth: '100%',
      }}
    >
      <span style={{ wordBreak: 'break-word' }}>{preview}</span>
      {truncado ? (
        <Tooltip title="Ver texto completo">
          <span
            role="button"
            tabIndex={0}
            aria-label={`Ver texto completo: ${nomeColuna || 'coluna'}`}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              cursor: carregando ? 'wait' : 'pointer',
              padding: '0 4px',
            }}
            onClick={event => {
              event.preventDefault();
              event.stopPropagation();
              if (!carregando && onVerCompleto) onVerCompleto();
            }}
            onKeyDown={event => {
              if (event.key !== 'Enter' && event.key !== ' ') return;
              event.preventDefault();
              event.stopPropagation();
              if (!carregando && onVerCompleto) onVerCompleto();
            }}
          >
            <Icons.EyeOutlined />
          </span>
        </Tooltip>
      ) : null}
    </span>
  );
}

export function ModalTextoColunaCompleto({
  aberto,
  titulo,
  texto,
  carregando,
  onClose,
}) {
  return (
    <Modal
      title={titulo || 'Texto completo'}
      visible={aberto}
      onCancel={onClose}
      width={720}
      maxHeight="70vh"
      maskClosable
    >
      <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
        {carregando ? 'Carregando...' : texto || '—'}
      </div>
    </Modal>
  );
}

export default TextoColunaCompleto;
